export default __webpack_public_path__ + "static/logo-513379f1cc8ad0ecfdb1f5f9b207a7ee.svg";